import { Helmet } from "react-helmet";
import type { IStructuredData } from "./types";

const StructuredData = ({ page }: { page: any }) => {
  let structuredData: IStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Blazpay Crypto Rewards Dashboard",
    url: "https://rewards.blazpay.com",
    description:
      "Earn the best crypto rewards and airdrops with Blazpay's rewards dashboard. Play games, complete daily tasks, stake crypto, and climb the leaderboard to maximize your crypto earnings.",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://rewards.blazpay.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  if (page === "website") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Blazpay",
      url: "https://rewards.blazpay.com",
      logo: "https://rewards.blazpay.com/logo.webp",
      description:
        "Earn the best crypto rewards and airdrops with Blazpay's rewards dashboard. Play games, complete daily tasks, stake crypto, and climb the leaderboard to maximize your crypto earnings.",
      sameAs: [
        "https://twitter.com/blazpay",
        "https://discord.gg/blazpay",
        "https://instagram.com/blazpay",
      ],
      keywords:
        "rewards dashboard crypto, rewards crypto, airdrop crypto, best crypto rewards, best rewards airdrop, crypto earning platform, blazpay rewards, crypto games rewards",
    };
  }

  if (page === "dashboard") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Crypto Rewards Dashboard | Blazpay",
      description:
        "Track and earn crypto rewards, complete daily tasks, and view your progress on the Blazpay rewards dashboard.",
      url: "https://rewards.blazpay.com/dashboard",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Daily Tasks",
            url: "https://rewards.blazpay.com/daily-tasks",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Quests",
            url: "https://rewards.blazpay.com/quests",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Leaderboard",
            url: "https://rewards.blazpay.com/leaderboard",
          },
        ],
      },
    };
  } else if (page === "leaderboard") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "Table",
      name: "Crypto Rewards Leaderboard | Blazpay",
      description:
        "View the top crypto rewards earners on Blazpay's leaderboard and compete for the best rewards and airdrops.",
      url: "https://rewards.blazpay.com/leaderboard",
      keywords:
        "crypto rewards leaderboard, best crypto rewards, rewards dashboard crypto, crypto ranking, airdrop crypto, blazpay leaderboard",
    };
  } else if (page === "store") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Crypto Rewards Store | Blazpay",
      description:
        "Shop and redeem your earned crypto rewards in the Blazpay store. Get exclusive items with your crypto rewards and airdrops.",
      url: "https://rewards.blazpay.com/store",
      keywords:
        "crypto rewards store, redeem crypto rewards, best crypto rewards, rewards crypto, blazpay store, crypto marketplace",
    };
  } else if (page === "gaming-marketplace") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Crypto Games & Rewards | Blazpay",
      description:
        "Play games to earn the best crypto rewards and airdrops on Blazpay. Our play-to-earn platform offers multiple ways to earn crypto rewards.",
      url: "https://rewards.blazpay.com/gaming-marketplace",
      keywords:
        "crypto games rewards, play to earn crypto, rewards crypto, best crypto rewards, crypto earning games, blazpay games",
    };
  } else if (page === "daily-tasks") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Daily Crypto Tasks | Blazpay",
      description:
        "Complete daily tasks to earn crypto rewards and airdrops on Blazpay. Our daily rewards system helps you maximize your crypto earnings.",
      url: "https://rewards.blazpay.com/daily-tasks",
      keywords:
        "daily crypto rewards, crypto tasks, rewards dashboard crypto, daily airdrop crypto, best crypto rewards, blazpay daily tasks",
    };
  } else if (page === "referral") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Crypto Referral Program | Blazpay",
      description:
        "Refer friends to Blazpay and earn crypto rewards. Our referral program offers some of the best crypto rewards for bringing new users.",
      url: "https://rewards.blazpay.com/refer",
      keywords:
        "crypto referral program, referral rewards crypto, best crypto rewards, airdrop crypto, blazpay referral, earn crypto referrals",
    };
  } else if (page === "chains") {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Supported Blockchain Networks | Blazpay",
      description:
        "Explore all blockchain networks supported by Blazpay for crypto rewards, games, and airdrops. Earn rewards on Polygon, Arbitrum, BNB Chain, Manta Pacific, Linea and more.",
      url: "https://rewards.blazpay.com/chains",
      keywords:
        "blockchain networks, crypto rewards chains, multi-chain crypto rewards, polygon rewards, arbitrum rewards, bnb chain rewards, manta pacific, linea blockchain, crypto airdrops, blazpay supported chains",
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
